module.exports = __webpack_public_path__ + "img/IMG_1458_L_WoodMatted_MockedUp.a2af76a5.jpg";